import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SidebarEntity } from '@app-core/data/sidebar.data';
import { SidebarService } from '@app-core/providers/sidebar.service';
import { UserPrincipalService } from '@app-core/providers/user-principal.service';
import { routerTransition } from '@shared/transitions/router.transitions';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [SidebarService],
  animations: [routerTransition]
})
export class HomeComponent {

  public menuItems: Promise<SidebarEntity[]> = this.sidebar.getMenuItems();

  public sideNavMode$: BehaviorSubject<string> = new BehaviorSubject(this.sideNavMode);
  public sideNavOpenStatus$: BehaviorSubject<boolean> = this.sidebar.sideNavOpenStatus$;

  constructor(private sidebar: SidebarService,
              private router: Router,
              private userService: UserPrincipalService) {
    fromEvent(window, 'resize')
      .pipe(debounceTime(300))
      .subscribe(_ => {
        if (this.isDesktopScreen) {
          this.sideNavOpenStatus$.next(true);
        }
        this.sideNavMode$.next(this.sideNavMode);
      });

    this.router.events
      .subscribe(async event => {
        if (event instanceof NavigationEnd) {
          // TODO: Now I do redirect to the first available route
          if (event.urlAfterRedirects === '/') {
            const [menuItem, ] = await this.menuItems;
            this.router.navigate(menuItem.routerLink);
          }

          if (!this.isDesktopScreen && this.sideNavOpenStatus$.value) {
            this.sideNavOpenStatus$.next(false);
          }

          this.userService.fetchBalance();

        }
      });
  }

  private get sideNavMode(): string {
    return this.isDesktopScreen ? 'side' : 'over';
  }

  private get isDesktopScreen(): boolean {
    return window.innerWidth > 800;
  }

  public updateOpenedStatus(state: boolean) {
    this.sideNavOpenStatus$.next(state);
  }

  getState(outlet) {
    return outlet.activatedRouteData.state;
  }

}
